import emmanuelPic from "@/public/images/artists/emmanuel.png";
import { Artist } from "@/types/types";

export const emmanuel = {
  id: "132",
  name: "Emmanuel",
  image: emmanuelPic,
  description: `Emmanuel's voice blends technical skill with emotive power, distinguished by its lush tone, precise pitch, versatile dynamics, and poignant expressiveness, ideally suited for Latin and pop genres.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Femmanuel-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Latin", "RnB", "Hip Hop", "Pop", "Dance", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 43,
        high: 63,
      },
      sweetSpot: 54,
    },
  },
} as const satisfies Artist;
